import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { TranslationProvider } from "./contexts/TranslationContext";
import { Navbar, EditorialRibbon, Footer } from "./components/Layout";
import Home from "./pages/Home";
import BlogList from "./pages/BlogList";
import PostDetail from "./pages/PostDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AffiliateDisclosure from "./pages/AffiliateDisclosure";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function CanonicalLink() {
  const { pathname } = useLocation();

  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    const cleanPath = pathname.endsWith("/") && pathname !== "/"
      ? pathname.slice(0, -1)
      : pathname;
    link.setAttribute("href", `https://githy.com${cleanPath}`);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <TranslationProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <CanonicalLink />
          <div className="min-h-screen flex flex-col">
            <Navbar />
            <EditorialRibbon />
            <main className="flex-1" data-testid="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/articles" element={<BlogList />} />
                <Route path="/category/:slug" element={<BlogList />} />
                <Route path="/post/:slug" element={<PostDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster position="bottom-right" richColors />
          {/* Hidden Google Translate container */}
          <div id="google_translate_element" style={{ display: "none" }}></div>
        </BrowserRouter>
      </AuthProvider>
    </TranslationProvider>
  );
}

export default App;
